<template>
  <v-container>
    <v-menu
      v-if="selectedItem !== null"
      v-model="showMenu"
      v-click-outside="close"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      class="menu"
      light
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in itemsToShow"
          :key="index"
          @click="optionSelected(item)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :href="computePath()" target="_blank">
          <v-list-item-action>
            <v-icon>mdi-open-in-new</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Open in new tab</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-container>
</template>

<script>
import { EventBus } from '../../mixins';

export default {
  data: () => ({
    showMenu: false,
    x: 0,
    y: 0,
    selectedItem: null,
    items: []
  }),
  computed: {
    itemsToShow: function () {
      return this.items;
    }
  },
  methods: {
    optionSelected (item) {
      this.$refs[item.ref].open(this.selectedItem);
    },
    computePath () {
      return `/customer/${this.selectedItem.uuid}`;
    },
    close () {
      if (this.showMenu) {
        EventBus.$emit('unselectItem');
      }
    },
    show (e, item) {
      e.preventDefault();
      this.selectedItem = item;

      // this.showMenu = false

      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    }
  }
};

</script>

<style scoped>
    .menu {
        margin: 0 auto;
        max-width: 600px;
        min-width: 120px;
        width: 120px;
    }
</style>
